import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const shell = {
  minHeight: "100vh", display: "flex", alignItems: "center",
  justifyContent: "center", background: "#0a0806", color: "#D4AF37",
  fontFamily: "Inter, system-ui, sans-serif", letterSpacing: "2px", fontSize: "13px",
};

export const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div style={shell} data-testid="auth-verifying">VERIFYING ACCESS…</div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
};

export default ProtectedRoute;
